import { useNavigate } from 'react-router-dom';

const AgeVerificationModal = ({ onConfirm }) => {
    const navigate = useNavigate();

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center px-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 sm:p-8 flex flex-col gap-4 text-center">
                <h2 className="text-lg font-bold text-gray-900">Age Verification Required</h2>
                <p className="text-sm text-gray-600">
                    This section contains alcohol products. You must be <span className="font-semibold">18 years of age or older</span> to view or purchase these items.
                </p>

                <div className="border-t border-gray-100 my-1"></div>

                <h2 className="text-lg font-bold text-gray-900">年齡驗證</h2>
                <p className="text-sm text-gray-600">
                    此分類包含酒類產品。您必須年滿 <span className="font-semibold">18 歲</span> 方可瀏覽或購買這些商品。
                </p>

                <div className="flex flex-col sm:flex-row gap-3 mt-2">
                    <button
                        onClick={() => navigate('/')}
                        className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 font-medium rounded-sm hover:bg-gray-50"
                    >
                        I am under 18 / 我未滿18歲
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-2.5 px-4 bg-primary-orange text-white font-medium rounded-sm shadow hover:shadow-lg"
                    >
                        I am 18+ / 我已年滿18歲
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AgeVerificationModal;